'use client';
import React, { useState } from 'react';
import Image from 'next/image';

import { Accordion, Button, Menu, MenuItem, Typography } from 'lighthouse';

import SwipeableDrawer from '@/widgets/SwipeableDrawer';

import { CategoryFilter } from './components/CategoryFilter';
import { SidebarTitle } from './components/SidebarTitle';
import classes from './index.module.css';

import { Filter, Sort } from 'iconsax-react';

const CategoryLayout = ({ children, categoriesData, categories }: { children: any; categoriesData: any[]; categories: any[] }) => {
    const [isFiltersOpen, setisFiltersOpen] = useState(false);
    const [filterValue, setFilterValue] = useState('جدیدترین');

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (e: any) => {
        setFilterValue(e.target.id);
        setAnchorEl(null);
    };

    const filtersList = [
        { id: 1, name: 'جدیدترین' },
        { id: 2, name: 'پربازدیدترین' },
        { id: 3, name: 'پرفروش‌ترین' },
        { id: 4, name: 'ارزان‌ترین' },
        { id: 5, name: 'گران‌ترین' }
    ];

    return (
        <div className='min-h-screen bg-gray-50 px-4' dir='rtl'>
            <div className='desktop-width mx-auto pt-4'>
                <div className='grid grid-cols-1 gap-4 lg:grid-cols-12'>
                    <aside className='hidden space-y-3 lg:col-span-3 lg:block'>
                        <div className='overflow-hidden rounded-lg border border-solid border-gray-100 bg-white'>
                            <Accordion
                                typographyProps={{ variant: 'subtitle2', component: 'div' }}
                                accordionShadow='elevation1'
                                accordionSummery={<SidebarTitle title='فروشندگان' />}
                                defaultExpanded
                                component='div'>
                                <div className='space-y-2'>
                                    {categoriesData.map((seller) => (
                                        <div key={seller.id} className='group flex items-center gap-4 rounded-lg p-2 hover:bg-blue-50/50'>
                                            <Image src='/images/logo/Azkiservice-single-logo.png' alt={seller.name} width={26} height={26} />
                                            <label className='flex flex-1 cursor-pointer items-center justify-between text-sm'>
                                                <Typography className='font-semibold text-blackMediumEmphasis group-hover:text-primary'>
                                                    {seller.name}
                                                </Typography>
                                                <span
                                                    className='rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-500
                                                        group-hover:bg-blue-100 group-hover:text-blue-600'>
                                                    {seller.count.toLocaleString()} محصول
                                                </span>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </Accordion>
                        </div>

                        {categories.map((el) => (
                            <CategoryFilter key={el.id} categories={categories} />
                        ))}
                    </aside>

                    <main className='lg:col-span-9'>
                        <div className='flex'>
                            <div
                                className='flex w-full items-center justify-between gap-2 rounded-lg border border-solid border-gray-100 bg-white px-2
                                    py-2'>
                                <div className='hidden items-center gap-2 sm:flex'>
                                    <Sort color='currentcolor' size='24' className='text-blackLowEmphasis' />
                                    <Typography className='min-w-fit text-sm font-bold text-blackMediumEmphasis'>مرتب سازی :</Typography>

                                    {filtersList.map((el) => (
                                        <Button key={el.id} color='blackMediumEmphasis'>
                                            {el.name}
                                        </Button>
                                    ))}
                                </div>

                                <div className='block w-full sm:hidden'>
                                    <Button
                                        id='basic-button'
                                        aria-controls={open ? 'basic-menu' : undefined}
                                        aria-haspopup='true'
                                        aria-expanded={open ? 'true' : undefined}
                                        onClick={handleClick}>
                                        <div className='flex items-center gap-2'>
                                            <Sort color='currentcolor' size='28' className='text-blackLowEmphasis' />
                                            <Typography className='min-w-fit text-sm font-bold text-blackMediumEmphasis'>مرتب سازی :</Typography>
                                            <Typography color='blackMediumEmphasis'>{filterValue}</Typography>
                                        </div>
                                    </Button>
                                    <Menu
                                        id='basic-menu'
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        MenuListProps={{
                                            'aria-labelledby': 'basic-button'
                                        }}>
                                        {filtersList.map((el) => (
                                            <MenuItem key={el.id} id={el.name} onClick={handleClose}>
                                                {el.name}
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </div>
                                <Button
                                    variant='text'
                                    onClick={() => setisFiltersOpen(true)}
                                    className={`block w-fit px-2 lg:hidden ${classes.filterButton}`}>
                                    <Filter size='32' className='text-primary' variant='Bold' color='currentcolor' />
                                </Button>
                            </div>
                        </div>

                        <div className='gap-4' style={{ containerType: 'inline-size' }}>
                            {children}
                        </div>
                    </main>
                </div>

                <div className='block lg:hidden'>
                    {isFiltersOpen && (
                        <div>
                            <SwipeableDrawer onClose={() => setisFiltersOpen(false)} open={true}>
                                <Accordion
                                    typographyProps={{ variant: 'subtitle2', component: 'div' }}
                                    accordionShadow='elevation1'
                                    accordionSummery={<SidebarTitle title='فروشندگان' />}
                                    defaultExpanded
                                    component='div'>
                                    <div className='space-y-2'>
                                        {categoriesData.map((seller) => (
                                            <div key={seller.id} className='group flex items-center gap-4 rounded-lg p-2 hover:bg-blue-50/50'>
                                                <Image src='/images/logo/Azkiservice-single-logo.png' alt={seller.name} width={26} height={26} />
                                                <label className='flex flex-1 cursor-pointer items-center justify-between text-sm'>
                                                    <Typography className='font-semibold text-blackMediumEmphasis group-hover:text-primary'>
                                                        {seller.name}
                                                    </Typography>
                                                    <span
                                                        className='rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-500
                                                            group-hover:bg-blue-100 group-hover:text-blue-600'>
                                                        {seller.count.toLocaleString()} محصول
                                                    </span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </Accordion>
                                {categories.map((el) => (
                                    <CategoryFilter key={el.id} categories={categories} />
                                ))}
                            </SwipeableDrawer>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CategoryLayout;
